<template>
<v-main>
  <v-layout justify-center class="mt-2">
    <v-card width="1200" class="rounded-xl">
      <v-layout column justify-center>
        <h1>
         <p class="text-center font-weight-bold">
            Alterar Vídeo
          </p>
          <!-- {{recepcionista}} -->
        </h1>

          <v-form ref="form" v-model="valid" class="px-4">
            <!-- nomeiN{{nomeInicial}} LINKiNI {{linkInicial}} -->
            <v-text-field v-model="nome" :rules="nomeRules" :type="'text'" name="input-10-1" label="Nome para o Vídeo" counter @click:append="show1 = !show1" />
            <v-text-field v-model="link" :rules="IdRules" :type="'text'" name="input-10-1" label="Link" counter @click:append="show1 = !show1" />

            <v-checkbox v-model="checkbox" label="Você concorda?" :rules="[(v) => !!v || 'Voce deve concordar para salvar!']" required />
            <v-alert :value="erroEditar" color="error" icon="warning" outlined>
              {{ msgErro }}
            </v-alert>

            <v-alert :value="sucessoEditar" color="success" icon="check_circle" outlined>
              Sucesso ao alterar dados!
            </v-alert>

          </v-form>

      </v-layout>
      <v-card-actions>
            <v-spacer />
            <v-btn rounded :disabled="desabilitar" dark :class="{ red: !valid, green: valid }" @click="alterarVideo">
              Salvar
            </v-btn>
            <v-btn text to="/listaVideos" @click="">
              <v-icon left>
                keyboard_backspace
              </v-icon>
              voltar
            </v-btn>
      </v-card-actions>
    </v-card>
  </v-layout>
</v-main>
</template>

<script>
import Cookies from 'js-cookie'
import administradorDesenvolvimentoService from '../../services/administradorDesenvolvimento.service'

// import EventBus from '../../../main';

export default {
  name: 'EditarUnidade',
  components: {
    // HelloWorld
  },
  data () {
    return {
      erroEditar: false,
      desabilitar: false,
      msgErro: '',
      link: '',
      linkInicial: '',
      nome: '',
      nomeInicial: '',
      idVideo: '',
      sucessoEditar: false,
      isEditing: true,
      valid: false,
      checkbox: false,
      nomeRules: [
        (v) => v && v.length > 0 || 'nome não pode ser vazio'
      ],
      IdRules: [
        (v) => v && v.length > 0 || 'o vídeos deve possuir um ID embed'
      ]
    }
  },
  mounted () {
    this.erroEditar = false,
    this.sucessoEditar = false
    this.user = this.$store.getters.usuario
    if (!this.$route.params.item) {
      // this.$router.push('/listaVideos')
      return
    }
    console.log('parametro', this.$route.params.item)
    this.idVideo = this.$route.params.item.idVideo
    this.nomeInicial = this.$route.params.item.nome
    this.nome = this.$route.params.item.nome
    this.linkInicial = this.$route.params.item.link
    this.link = this.$route.params.item.link
  },

  created () {
    // this.$eventHub.$on('logged-in', this.setaDescricao)
    console.log('created...')
  },
  methods: {

    alterarVideo () {
      console.log('em elter vid admDev')
      if (this.link == this.linkInicial && this.nomeInicial == this.nome) {
        this.msgErro = 'Nada alterado. você deve alterar para salvar.'
        this.erroEditar = true
        return
      }

      if (this.$refs.form.validate()) {
        this.erroEditar = false
        this.sucessoEditar = false
        administradorDesenvolvimentoService.administradorDesenvolvimento
          .alterarVideo(this.idVideo, this.nome, this.link)
          .then(rsp => {
            console.log('rsp oi:', rsp.data)
            if (rsp.data == 'erro') {
              this.desabilitar = false
              this.msgErro = 'Erro ao editar'
              this.erroEditar = true
            }
            if (rsp.data == true) {
              this.sucessoEditar = true
              this.clear()
              setTimeout(() => this.$router.push({
                path: '/listaVideos'
              }), 2000)
            }
            // console.log(this.listaChamadas);
            // this.servicoTeste = rsp.data
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },

    clear () {
      this.$refs.form.reset()
    }

  }
}
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31B0D5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: -4px;
  right: 10px;
}
</style>
